import type { EmailMfaStatus } from './authTypes';

export type { EmailMfaStatus };

async function callAuthFunction(name: string, data: Record<string, unknown> = {}) {
  const { callFunction } = await import('./firebase/FunctionsService.js');
  return callFunction(name, data);
}

export async function getEmailMfaStatus(): Promise<EmailMfaStatus> {
  try {
    const result = await callAuthFunction('getEmailMfaStatus') as { enrolled?: boolean };
    return { enrolled: Boolean(result?.enrolled) };
  } catch {
    return { enrolled: false };
  }
}

export async function sendEmailMfaCode(purpose: 'enroll' | 'signin' = 'enroll'): Promise<void> {
  await callAuthFunction('sendEmailMfaCode', { purpose });
}

export async function verifyEmailMfaEnrollment(code: string): Promise<EmailMfaStatus> {
  const result = await callAuthFunction('verifyEmailMfaEnrollment', { code }) as { enrolled?: boolean };
  return { enrolled: Boolean(result?.enrolled) };
}

export async function verifyEmailMfaSignIn(code: string): Promise<void> {
  await callAuthFunction('verifyEmailMfaSignIn', { code });
}

export async function disableEmailMfa(): Promise<EmailMfaStatus> {
  const result = await callAuthFunction('disableEmailMfa') as { enrolled?: boolean };
  return { enrolled: Boolean(result?.enrolled) };
}
